import React from 'react'
import Sidebar from '../../components/Sidebar'
import Navbar from '../../components/Navbar'
import ACFailReportComponent from '../../components/ACFailReportComponent/ACFailReportComponent'

const ACFailReport = () => {
    return (
        <div>
            <div className='flex'>
                <div className='w-[15%]'>
                    <Sidebar />
                </div>
                <div>
                    <Navbar />
                    <ACFailReportComponent/>
                </div>
            </div>
        </div>
    )
}

export default ACFailReport
